<template><div><h1>VUX V2.5.6 发布日志</h1>
<h2><a href="/zh-CN/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[fix] 修复取消菜单上的 json 解析错误 #1782</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[feature] 支持在滑动 picker 时触发事件 on-shadow-change #1778</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] 支持在滑动 picker 时触发事件 on-shadow-change #1778</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[fix] 修复 is-type 验证逻辑 #1776</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.6 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.6-248.vue?550329cf